"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var categories_1 = require("../../../api/calls/product/categories");
var products_by_category_1 = require("../../../api/calls/product/products_by_category");
var getRootPath_1 = require("../../../helpers/getRootPath");
var main_1 = require("../../../reducers/slices/main");
// import { IBasketSliceState } from "../../../reducers/slices/basket";
var selection_1 = require("../../../reducers/slices/selection");
var category_products_1 = require("./category_products");
var recommended_deals_1 = require("../../components/recommended_deals");
var hot_deals_1 = require("../../components/hot_deals");
var recently_viewed_1 = require("../../components/recently_viewed");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var get_favourite_ids_1 = require("../../../api/calls/product/get_favourite_ids");
var favourite_product_1 = require("../../../api/calls/product/favourite_product");
var add_to_basket_thunk_1 = require("../../../reducers/slices/basket/thunks/add_to_basket_thunk");
var choice_card_1 = require("../../components/choice_card");
var shop_banners_1 = require("../../components/shop_banners");
var image_default_png_1 = __importDefault(require("../../../assets/image_default.png"));
var google_tags_1 = require("../../../constants/google_tags");
var ShopPage = function () {
    var params = (0, react_router_dom_1.useParams)();
    var shopByType = params.shopByType;
    var location = (0, react_router_dom_1.useLocation)();
    var rootPath = (0, getRootPath_1.getRootPath)(location);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    // const { products } = useSelector<any, IBasketSliceState>((state) => state.basketState);
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)([]), categories = _a[0], setCategories = _a[1];
    var _b = (0, react_1.useState)([]), random1Category = _b[0], setRandom1Category = _b[1];
    var _c = (0, react_1.useState)([]), random2Category = _c[0], setRandom2Category = _c[1];
    var _d = (0, react_1.useState)([]), random1Products = _d[0], setRandom1Products = _d[1];
    var _e = (0, react_1.useState)(1), random1TotalRecords = _e[0], setRandom1TotalRecords = _e[1];
    var _f = (0, react_1.useState)(4), random1RecordsPerPage = _f[0], setRandom1RecordsPerPage = _f[1]; //Change this
    var _g = (0, react_1.useState)(1), random1CurrentPage = _g[0], setRandom1CurrentPage = _g[1];
    var _h = (0, react_1.useState)([]), random2Products = _h[0], setRandom2Products = _h[1];
    var _j = (0, react_1.useState)(1), random2TotalRecords = _j[0], setRandom2TotalRecords = _j[1];
    var _k = (0, react_1.useState)(4), random2RecordsPerPage = _k[0], setRandom2RecordsPerPage = _k[1]; //Change this
    var _l = (0, react_1.useState)(1), random2CurrentPage = _l[0], setRandom2CurrentPage = _l[1];
    var _m = (0, react_1.useState)([]), favouriteIds = _m[0], setFavouriteIds = _m[1];
    (0, react_1.useEffect)(function () {
        init();
    }, [user]);
    var init = function () {
        if (user === null || user === void 0 ? void 0 : user._id) {
            (0, get_favourite_ids_1.get_favourite_ids)().then(function (response) {
                if (response.success) {
                    setFavouriteIds(response.content);
                }
            });
        }
        else {
            setFavouriteIds(null);
        }
    };
    (0, react_1.useEffect)(function () {
        (0, categories_1.getCategories)().then(function (response) {
            if (response.success) {
                var ls = response.content;
                var shopCategory = void 0;
                if (shopByType == "themes") {
                    shopCategory = ls.find(function (c) { return c.name.toLowerCase() == "theme"; });
                }
                else {
                    shopCategory = ls.find(function (c) { return c.name.toLowerCase() == "shop"; });
                }
                if (shopCategory) {
                    (0, categories_1.getCategories)({
                        // page: "1",
                        parent_id: shopCategory.id,
                    }).then(function (response) {
                        if (response.success) {
                            var newCategoryList = [];
                            for (var _i = 0, _a = response.content; _i < _a.length; _i++) {
                                var category = _a[_i];
                                newCategoryList.push({
                                    _id: category.id,
                                    title: category.name,
                                    expanded: false,
                                    items: category.sub_categories.map(function (sub_category, index) { return ({
                                        _id: sub_category.id,
                                        title: sub_category.name,
                                    }); }),
                                });
                            }
                            setCategories(newCategoryList);
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Failed to retrieve categories", messages: [response.message] }));
                        }
                    });
                }
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: "Failed to retrieve root level categories", messages: [response.message] }));
            }
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (categories && categories.length > 0) {
            var randCat1 = categories[Math.floor(Math.random() * categories.length)];
            if (randCat1.items && randCat1.items.length > 0) {
                var randSubCat1 = randCat1.items[Math.floor(Math.random() * randCat1.items.length)];
                setRandom1Category(randSubCat1);
            }
            //
            var randCat2 = categories[Math.floor(Math.random() * categories.length)];
            if (randCat2.items && randCat2.items.length > 0) {
                while (randCat2._id == randCat1._id) {
                    randCat2 = categories[Math.floor(Math.random() * categories.length)];
                }
                var randSubCat2 = randCat2.items[Math.floor(Math.random() * randCat2.items.length)];
                setRandom2Category(randSubCat2);
            }
        }
    }, [categories]);
    (0, react_1.useEffect)(function () {
        if (random1Category === null || random1Category === void 0 ? void 0 : random1Category._id) {
            getRandom1Products(random1Category._id);
        }
    }, [random1Category, favouriteIds]);
    (0, react_1.useEffect)(function () {
        if (random1Category === null || random1Category === void 0 ? void 0 : random1Category._id) {
            getRandom1Products(random1Category._id);
        }
    }, [random1CurrentPage]);
    (0, react_1.useEffect)(function () {
        if (random2Category === null || random2Category === void 0 ? void 0 : random2Category._id) {
            getRandom2Products(random2Category._id);
        }
    }, [random2Category, favouriteIds]);
    (0, react_1.useEffect)(function () {
        if (random2Category === null || random2Category === void 0 ? void 0 : random2Category._id) {
            getRandom2Products(random2Category._id);
        }
    }, [random2CurrentPage]);
    var getRandom1Products = function (categporyId) {
        // getProductsByCategory({
        (0, products_by_category_1.getProductsByCategory)({
            category_id: categporyId,
        }).then(function (response) {
            var list = response.content.products;
            setRandom1TotalRecords(response.content.products.length);
            setRandom1RecordsPerPage(response.content.products.length); //To Do
            setRandom1Products(list.map(function (product) {
                return {
                    _id: product._id,
                    title: product.title,
                    image: !(product === null || product === void 0 ? void 0 : product.image_url) ? image_default_png_1.default : product === null || product === void 0 ? void 0 : product.image_url,
                    loaderColor: "text-primary",
                    shadowColor: "shadow-shadows",
                    borderColor: "border-none",
                    amount: product === null || product === void 0 ? void 0 : product.price,
                    amountColor: "text-primary",
                    // rating: product?.rating?.average ?? 0,
                    discountLabel: (product === null || product === void 0 ? void 0 : product.on_promotion) ? "ON PROMOTION" : "",
                    discountAmount: (product === null || product === void 0 ? void 0 : product.on_promotion) ? product === null || product === void 0 ? void 0 : product.promotion_price : null,
                    pid: product === null || product === void 0 ? void 0 : product.pid,
                    status: product === null || product === void 0 ? void 0 : product.status,
                    sku: product === null || product === void 0 ? void 0 : product.sku,
                    sub_title: product === null || product === void 0 ? void 0 : product.sub_title,
                    description: product === null || product === void 0 ? void 0 : product.description,
                    instruction: product === null || product === void 0 ? void 0 : product.instruction,
                    estimated_delivery_time: product === null || product === void 0 ? void 0 : product.estimated_delivery_time,
                    promotion_price: product === null || product === void 0 ? void 0 : product.promotion_price.toString(),
                    on_promotion: product === null || product === void 0 ? void 0 : product.on_promotion,
                    outOfStock: (product === null || product === void 0 ? void 0 : product.status) != "AVAILABLE" ? true : false,
                    colors: {
                        discount: {
                            textColor: "text-white",
                            amountColor: "text-red-500",
                            backgroundColor: "bg-red-500",
                        },
                        extraText: {
                            textColor: "text-success",
                        },
                        outOfStock: {
                            textColor: "text-white",
                            backgroundColor: "bg-gray-400",
                        },
                    },
                    favorite: {
                        icon: (favouriteIds === null || favouriteIds === void 0 ? void 0 : favouriteIds.find(function (x) { return x === product.pid; })) ? pro_solid_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart !== null && pro_light_svg_icons_1.faHeart !== void 0 ? pro_light_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart,
                        iconColor: "text-red-500",
                        onClick: function () {
                            var _a;
                            if (user._id) {
                                (0, favourite_product_1.favorite_product)({
                                    product_id: product.pid,
                                    category_id: (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.integration_id,
                                    product_name: product.title,
                                }).then(function (response) {
                                    if (response.success) {
                                        init();
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Success",
                                            messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                        }));
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Failed",
                                            messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                        }));
                                    }
                                });
                            }
                            else {
                                dispatch((0, main_1.setDrawerPage)("login"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            }
                        },
                    },
                };
            }));
        });
    };
    var getRandom2Products = function (categporyId) {
        // getProductsByCategory({
        (0, products_by_category_1.getProductsByCategory)({
            category_id: categporyId,
        }).then(function (response) {
            var list = response.content.products;
            setRandom2TotalRecords(response.content.products.length);
            setRandom2RecordsPerPage(response.content.products.length); //To Do
            setRandom2Products(list.map(function (product) {
                return {
                    _id: product._id,
                    title: product.title,
                    image: !(product === null || product === void 0 ? void 0 : product.image_url) ? image_default_png_1.default : product === null || product === void 0 ? void 0 : product.image_url,
                    amount: product === null || product === void 0 ? void 0 : product.price,
                    loaderColor: "text-primary",
                    shadowColor: "shadow-shadows",
                    borderColor: "border-none",
                    amountColor: "text-primary",
                    //  rating: product?.rating?.average ?? 0,
                    discountLabel: (product === null || product === void 0 ? void 0 : product.on_promotion) ? "ON PROMOTION" : "",
                    discountAmount: (product === null || product === void 0 ? void 0 : product.on_promotion) ? product === null || product === void 0 ? void 0 : product.promotion_price : null,
                    extraText: product.estimated_delivery_time ? "Estimated Delivery: ".concat(product.estimated_delivery_time, " ") : "",
                    pid: product === null || product === void 0 ? void 0 : product.pid,
                    status: product === null || product === void 0 ? void 0 : product.status,
                    sku: product === null || product === void 0 ? void 0 : product.sku,
                    sub_title: product === null || product === void 0 ? void 0 : product.sub_title,
                    description: product === null || product === void 0 ? void 0 : product.description,
                    instruction: product === null || product === void 0 ? void 0 : product.instruction,
                    estimated_delivery_time: product === null || product === void 0 ? void 0 : product.estimated_delivery_time,
                    promotion_price: product === null || product === void 0 ? void 0 : product.promotion_price.toString(),
                    on_promotion: product === null || product === void 0 ? void 0 : product.on_promotion,
                    outOfStock: (product === null || product === void 0 ? void 0 : product.status) != "AVAILABLE" ? true : false,
                    colors: {
                        discount: {
                            textColor: "text-white",
                            amountColor: "text-red-500",
                            backgroundColor: "bg-red-500",
                        },
                        extraText: {
                            textColor: "text-success",
                        },
                        outOfStock: {
                            textColor: "text-white",
                            backgroundColor: "bg-gray-400",
                        },
                    },
                    favorite: {
                        icon: (favouriteIds === null || favouriteIds === void 0 ? void 0 : favouriteIds.find(function (x) { return x === product.pid; })) ? pro_solid_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart !== null && pro_light_svg_icons_1.faHeart !== void 0 ? pro_light_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart,
                        iconColor: "text-red-500",
                        onClick: function () {
                            var _a;
                            if (user._id) {
                                (0, favourite_product_1.favorite_product)({
                                    product_id: product.pid,
                                    category_id: (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.integration_id,
                                    product_name: product.title,
                                }).then(function (response) {
                                    if (response.success) {
                                        init();
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Success",
                                            messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                        }));
                                    }
                                    else {
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Failed",
                                            messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                        }));
                                    }
                                });
                            }
                            else {
                                dispatch((0, main_1.setDrawerPage)("login"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            }
                        },
                    },
                };
            }));
        });
    };
    return (react_1.default.createElement("div", { className: "flex flex-col items-center" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(shop_banners_1.ShopBanner, null),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(recommended_deals_1.RecommendedDealsComponent, null)),
            react_1.default.createElement("div", { className: "flex flex-col lg:flex-row gap-4" },
                react_1.default.createElement("div", { className: "flex-none flex lg:flex-col gap-8 lg:max-w-[16rem]" },
                    react_1.default.createElement(doshx_controls_web_1.SideNavigationControl, { title: "Filter by ".concat(shopByType === "themes" ? "theme" : "category", " "), expandableLevels: [0, 1, 2], clickNameToExpand: true, clickNameAllowExpansion: true, items: categories, shadowColor: "shadow-shadows", borderColor: "border-none", onItemClick: function (item, level) {
                            window.scrollTo({
                                top: 450,
                                behavior: "smooth",
                            });
                            dispatch((0, selection_1.setSelectedCategory)({ item: item, level: level }));
                            navigate("".concat(rootPath, "/").concat(shopByType, "/").concat(shopByType === "themes" ? "theme" : "category", "/").concat(level, "/").concat(item._id));
                        } })),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(react_router_dom_1.Routes, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/*", element: react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                                react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { imageFit: "contain", category: {
                                        name: random1Category.title,
                                        color: "text-black",
                                    }, products: random1Products, 
                                    // button={{ borderColor: "border-primary", textColor: "text-primary", onClick: () => {} }}
                                    onClick: function (product) {
                                        dispatch((0, selection_1.setSelectedProduct)(product));
                                        navigate("/product/".concat(product._id));
                                    }, canIncrement: true, button: {
                                        label: "Cart",
                                        borderColor: "border-primary",
                                        backgroundColor: "bg-primary",
                                        textColor: "text-white",
                                        onClick: function (product) {
                                            dispatch((0, add_to_basket_thunk_1.add_product_thunk)(__assign({}, product)));
                                        },
                                    }, pagination: {
                                        currentPage: random1CurrentPage,
                                        totalRecords: random1TotalRecords,
                                        recordsPerPage: random1RecordsPerPage,
                                        onClick: function (pageNumber) {
                                            setRandom1CurrentPage(pageNumber);
                                        },
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { imageFit: "contain", category: {
                                        name: random2Category.title,
                                        color: "text-black",
                                    }, products: random2Products, 
                                    // button={{ borderColor: "border-primary", textColor: "text-primary", onClick: () => {} }}
                                    onClick: function (product) {
                                        (0, google_tags_1.trackProductClick)({
                                            products: [
                                                {
                                                    title: product.title,
                                                    _id: product._id,
                                                    price: product.amount,
                                                    quantity: product.quantity,
                                                    sku: "",
                                                },
                                            ],
                                            _id: product._id,
                                            price: product.amount,
                                        });
                                        dispatch((0, selection_1.setSelectedProduct)(product));
                                        navigate("/product/".concat(product._id));
                                    }, canIncrement: true, button: {
                                        label: "Cart",
                                        borderColor: "border-primary",
                                        backgroundColor: "bg-primary",
                                        textColor: "text-white",
                                        onClick: function (product) {
                                            dispatch((0, add_to_basket_thunk_1.add_product_thunk)(__assign({}, product)));
                                        },
                                    }, pagination: {
                                        currentPage: random2CurrentPage,
                                        totalRecords: random2TotalRecords,
                                        recordsPerPage: random2RecordsPerPage,
                                        onClick: function (pageNumber) {
                                            setRandom2CurrentPage(pageNumber);
                                        },
                                    } })) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/category/:level/:categoryId", element: react_1.default.createElement(category_products_1.CategoryProductsPage, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/theme/:level/:categoryId", element: react_1.default.createElement(category_products_1.CategoryProductsPage, null) })))),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(hot_deals_1.HotDealsComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(recently_viewed_1.RecentlyViewedComponent, null))),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(choice_card_1.ChoiceCardComponent, null))));
};
exports.ShopPage = ShopPage;
